import React from 'react';

type Props = {
  className?: string;
};

const Icon: React.FC<Props> = ({ className }: Props) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="#000" viewBox="0 0 20 20" className={className}>
    <mask
      id="mask0_4405_3388"
      style={{ maskType: 'alpha' }}
      width="50"
      height="50"
      x="0"
      y="0"
      maskUnits="userSpaceOnUse"
    >
      <path d="M0 0H50V50H0z"></path>
    </mask>
    <g mask="url(#mask0_4405_3388)">
      <path d="M9.533 7.867v-2.5h-2.5V3.7h2.5V1.2H11.2v2.5h2.5v1.667h-2.5v2.5H9.533zM6.2 18.7c-.458 0-.85-.163-1.177-.49a1.605 1.605 0 01-.49-1.177c0-.458.164-.85.49-1.177.326-.326.719-.49 1.177-.49.458 0 .85.164 1.177.49.326.327.49.719.49 1.177 0 .459-.164.851-.49 1.177-.326.327-.719.49-1.177.49zm8.333 0c-.458 0-.85-.163-1.177-.49a1.605 1.605 0 01-.49-1.177c0-.458.164-.85.49-1.177.327-.326.719-.49 1.177-.49.459 0 .851.164 1.177.49.327.327.49.719.49 1.177 0 .459-.163.851-.49 1.177-.326.327-.718.49-1.177.49zM1.2 3.7V2.033h2.73l3.54 7.5h5.834l3.25-5.833h1.896l-3.667 6.625a1.668 1.668 0 01-.614.646 1.62 1.62 0 01-.844.229H7.117L6.2 12.867h10v1.666h-10c-.625 0-1.1-.27-1.427-.812-.326-.542-.337-1.09-.031-1.646l1.125-2.042-3-6.333H1.2z"></path>
    </g>
  </svg>
);

export default Icon;
